// sensei-app/client/ui/StudentCalendar.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class StudentCalendar extends ComponentBase {
    constructor(config) {
        super(config);
        this.calendarView = null;
        this.studentId = null;
    }

    async initialize() {
        this.container = document.createElement("div");
        this.container.className = "h-100 position-relative"; // Parent needs position for child to fill it
        await super.initialize();
    }

    async initAfterLogin() {
        this.studentId = this.appClient.getSharedData("userId");
        if (this.studentId) {
            await this.render();
        }
    }

    async render() {
        this.container.innerHTML = "";
        if (!this.studentId) {
            this.container.innerHTML = `<p class="p-3 text-muted text-center">${this.t("Loading calendar...")}</p>`;
        } else {
            // Re-use or create the component.
            // createManagedComponent is smart enough not to re-create if the instanceId already exists.
            this.calendarView = await this.createManagedComponent(
                "CalendarView",
                this.container,
                {
                    instanceId: `student-calendar-main-${this.studentId}`,
                    contextId: this.studentId,
                    isEditable: true, // Let students add personal events
                    eventColorMap: { // Example of customizing colors from the app level
                        'class': 'var(--bs-info)',
                        'assessment': 'var(--bs-warning)',
                        'personal': 'var(--bs-success)',
                        'missed': 'var(--bs-danger)',
                        'cancelled': 'var(--bs-secondary)'
                    }
                }
            );
        }
        return this.container;
    }

    async refresh() {
        // This is still good practice to have.
        if (this.calendarView && typeof this.calendarView.onShow === "function") {
            await this.calendarView.onShow();
        } else if (this.studentId) {
            await this.render();
        }
    }

    destroy() {
        if (this.calendarView) {
            this.calendarView.destroy();
            this.calendarView = null;
        }
        super.destroy();
    }
}